import { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';
import { IApiDataResponse } from '../../dto/API.dto';
import {
  IMusicReview,
  INoPlayListRating,
} from '../../Service/musicReviewService';
import { ICompany } from '../../dto/Company.dto';
import { IUserBlackListProp } from '../../dto/User.dto';

export type IProcessingCenterProp = {
  id: number;
  requestable_type: string;
  requestable_id: number;
  file_path: string;
  file_name: string;
  meta_data_file_path: string;
};
export type ISongRequestView = IMusicReview & {
  processing_center: IProcessingCenterProp;
  company: ICompany;
};
export const songRequestViewUrl = (taskId: number) => {
  return `v1/task/${taskId}/song-request`;
};

const getSongRequestDetails = (taskId: number) => {
  return axiosInstance
    .get(songRequestViewUrl(taskId))
    .then((response: AxiosResponse<IApiDataResponse<ISongRequestView>>) => {
      return response.data?.data;
    });
};

export const useRqSongRequestDetails = (
  taskId: number,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: [songRequestViewUrl(taskId)],
    queryFn: () => getSongRequestDetails(taskId),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: enabled && Boolean(taskId),
  });
};

// List Rejected song requests.
export type IRejectedSongRequestProp = {
  id: number;
  song_request_id: number;
  file_name: string;
  final_review_notes: string;
  rejected_by: IUserBlackListProp;
  no_play_list_ratings: INoPlayListRating[];
  song_request: {
    id: number;
    processing_center: {
      id: number;
      file_path: string;
    };
  };
};
const rejectedSongRequestViewUrl = (taskId: number) => {
  return `v1/task/${taskId}/song-request-rejected`;
};

const getRejectedSongRequestDetails = (taskId: number) => {
  return axiosInstance
    .get(rejectedSongRequestViewUrl(taskId))
    .then(
      (
        response: AxiosResponse<IApiDataResponse<IRejectedSongRequestProp[]>>,
      ) => {
        return response.data?.data;
      },
    );
};

export const useRqRejectedSongRequestDetails = (
  taskId: number,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: [rejectedSongRequestViewUrl(taskId)],
    queryFn: () => getRejectedSongRequestDetails(taskId),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: enabled && Boolean(taskId),
  });
};
